export enum InstadrivePhoneNumber {
    // Main numbers
    FREEPHONE_MAIN_AT = '+43800404064',
    FREEPHONE_MAIN_DE = '+498008080906',
    FREEPHONE_MAIN_CH = '+41800564259',
    FREEPHONE_MAIN_FR = '+33800943006',

    GEOGRAPHIC_MAIN_AT = '+4319556717',
    GEOGRAPHIC_MAIN_DE = '+493020164910',
    GEOGRAPHIC_MAIN_CH = '+41435082373',
}
